<template>
  <div class="custom-filters-editor"
       :class="filterEditorStyles">
    <header-mobile-page :label="child.name" />
    <div class="header">
      Create or Edit Custom Filters
    </div>

    <custom-filter-editor ref="customFilterEditor"
                          :mode="mode"
                          :mode-id="modeId"
                          :child-id="childId"
                          :name="name"
                          :filter-id="filterId"
                          :keywords="keywords"
                          @focus="inputOnFocus"
                          @blur="inputOnBlur" />

    <custom-filter-navigation class="editor-navigation"
                              :mode="mode"
                              :mode-id="modeId"
                              :child-id="childId"
                              :create-loading="createLoading"
                              :update-loading="updateLoading"
                              :remove-loading="removeLoading"
                              :input-focused="inputFocused"
                              @create="create"
                              @update="update"
                              @remove="remove" />
  </div>
</template>

<script>
  import CustomFilterEditor from '@/components/Child/ChildCustomFilter/CustomFilterEditor'
  import CustomFilterNavigation from '@/components/Child/ChildCustomFilter/CustomFilterNavigation'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      CustomFilterEditor,
      CustomFilterNavigation,
      HeaderMobilePage
    },

    props: {
      mode: {
        type: String,
        required: false,
        default: 'create'
      },

      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      },

      name: {
        type: String,
        required: false,
        default: ''
      },

      filterId: {
        type: Number,
        required: false
      },

      keywords: {
        type: Array,
        required: false,
        default: () => []
      }
    },

    data() {
      return {
        createLoading: false,
        updateLoading: false,
        removeLoading: false,
        inputFocused: false
      }
    },

    methods: {
      create() {
        this.createLoading = true

        this.$refs.customFilterEditor.createFilter()
          .then(() => {
            this.createLoading = false
          })
      },

      update() {
        this.updateLoading = true

        this.$refs.customFilterEditor.updateFilter()
          .then(() => {
            this.updateLoading = false
          })
      },

      remove() {
        this.removeLoading = true

        this.$refs.customFilterEditor.removeFilter()
          .then(() => {
            this.removeLoading = false
          })
      },

      inputOnFocus() {
        this.inputFocused = true
      },

      inputOnBlur() {
        this.inputFocused = false
      }
    },

    computed: {
      filterEditorStyles() {
        return {
          'custom-filters-editor-creation': this.mode === 'create'
        }
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.childId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-filters-editor {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 0 20px 10px 20px;

    .header {
      color:map.get($colors, primary);
      font-size: 24px;
      text-align: center;
      margin-bottom: 20px;
    }

    .editor-navigation {
      position: fixed;
      bottom: 0;

      width: 100%;
      height: 100px;

      padding: 0 20px;
      background: #fff;
    }
  }

  .custom-filters-editor-creation {
    .editor-navigation {
      height: 60px;
    }
  }
</style>